import React, { useContext } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import en from 'date-fns/locale/en-US';

import 'react-datepicker/dist/react-datepicker.css';

import { LocaleContext } from 'context/LocaleContext';

const mondayLocale = {
    ...en,
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
const sundayLocale = {
    ...en,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
const saturdayLocale = {
    ...en,
    options: {
        weekStartsOn: 6,
        firstWeekContainsDate: 1
    }
};

registerLocale('en-1', mondayLocale);
registerLocale('en-0', sundayLocale);
registerLocale('en-6', saturdayLocale);


const LocalizedDatePicker = props => {
    const localeContext = useContext(LocaleContext);

    return (
        <DatePicker
            locale={`en-${localeContext.weekStart}`}
            timeFormat={localeContext.dateTimeFormats.time}
            {...props}
        />
    );
}

export default LocalizedDatePicker;
